package com.klantenstop.web.pages.admin.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.components.layout.AdminPageLayout
import com.materialkobweb.utils.rememberViewModel
import com.materialkobweb.utils.Logger
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.flow.collectLatest
import org.jetbrains.compose.web.css.px

@Page("/admin/instellingen")
@Composable
fun SettingsPage() {
    // Use constant key to maintain ViewModel across navigation
    val viewModel = rememberViewModel { SettingsViewModel() }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.effect.collectLatest { effect ->
            when (effect) {
                is SettingsContract.Effect.ShowError -> {
                    // TODO: Show error snackbar/toast
                    Logger.error("SettingsPage", effect.message)
                }

                is SettingsContract.Effect.ShowSuccess -> {
                    // TODO: Show success snackbar/toast
                    Logger.info("SettingsPage", effect.message)
                }
            }
        }
    }

    AdminPageLayout(
        title = "Settings"
    ) {
        SettingsContent(state = state, sendIntent = viewModel::sendIntent)
    }
}

@Composable
fun SettingsContent(
    state: SettingsContract.State,
    sendIntent: (SettingsContract.Intent) -> Unit
) {
    val colorMode = ColorMode.current

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(40.px),
        verticalArrangement = Arrangement.spacedBy(20.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            text = "Platform Settings",
            modifier = Modifier
                .fontSize(32.px)
                .fontWeight(FontWeight.Bold)
                .color(if (colorMode.isLight) Colors.Black else Colors.White)
        )

        SpanText(
            text = "Configure platform-wide settings and preferences",
            modifier = Modifier
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .color(if (colorMode.isLight) Colors.Gray else Colors.LightGray)
        )

        if (state.isLoading) {
            SpanText(
                text = "Loading settings...",
                modifier = Modifier
                    .fontSize(16.px)
                    .color(if (colorMode.isLight) Colors.Gray else Colors.LightGray)
            )
        }

        // TODO: Add tabs for different settings sections:
        //  - General (site name, description, contact info)
        //  - Email (SMTP settings, email templates)
        //  - Security (password policies, session timeout)
        //  - API (API keys, rate limits)
        //  - Appearance (logo, colors, theme)
        //  - Notifications (email notifications, push notifications)
        //  - Search (search radius limits, default location)
        //  - Reviews (moderation settings, minimum rating)
        //  - Users (registration settings, role permissions)

        // TODO: Add form fields for each setting
        // TODO: Add save button for each section
        // TODO: Add validation for settings fields
    }
}

